<template>
  <div>
    <el-form ref="formRef" :model="activationForm" label-width="88px">
      <el-form-item label="应用名：">
        <el-input type="text" v-model="activationForm.appName" size="medium" style="width:25em;" placeholder="请输入应用名"></el-input>
      </el-form-item>
      <el-form-item label="平台：">
        <el-select v-model="platformType" placeholder="请选择" size="medium" style="width: 8em;" @change="platformChange">
          <el-option v-for="item in platformTypeArray" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="包名/渠道：">
        <el-select v-model="channelPackage" placeholder="请选择" size="medium" style="width: 16em;" @change="cpChange">
          <el-option v-for="item in channelPackageArray" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户场景：">
        <el-select v-model="userScene" placeholder="请选择" size="medium" style="width: 16em;">
          <el-option v-for="item in userSceneArray" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="短信ID：">
        <el-input type="text" v-model="activationForm.project" size="medium" style="width:25em;" placeholder="请输入短信ID"></el-input>
      </el-form-item>
      <el-form-item label="短信来源：">
        <el-select v-model="smsSource" placeholder="请选择" size="medium" style="width: 8em;">
          <el-option v-for="item in smsSourceArray" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import {addOrUpdateActivationSms, getAddOrUpdateChannelPackage} from "@/api/url";

export default {
  name: "TagManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      activationForm: this.value.activationForm,
      idx: this.value.ids,
      loading: false,

      //平台
      platformTypeArray: [
        {label: "Android",value: 1},
        {label: "IOS",value: 2}
      ],
      platformType: 1,

      channelPackageArray: [],
      channelPackage: '',
      //渠道
      channelArray: [],
      channel: '',

      //包名
      packageNameArray: [],
      packageName: '',

      // 用户场景
      userSceneArray: [
        {label: "第一条短信：注册但未进入",value: '2-1'},
        {label: "第二条短信：注册但未进入",value: '2-2'},
        {label: "第三条短信：注册但未进入",value: '2-3'},
        {label: "第四条短信：注册但未进入",value: '2-4'},
        {label: "第一条短信：进入但未活跃",value: '1-1'},
        {label: "第二条短信：进入但未活跃",value: '1-2'}
      ],
      userScene: '2-1',

      // 短信来源
      smsSourceArray: [
        {label: "赛邮短信", value: 1},
        // {label: "示远短信", value: 2}
      ],
      smsSource: 1,

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.activationForm.appName) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '应用名不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.activationForm.project) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '短信ID不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let _this = this
      let param = {};
      param['id'] = this.activationForm.id?this.activationForm.id:0;
      param['appName'] = this.activationForm.appName;
      param['project'] = this.activationForm.project;
      param['platformType'] = this.platformType;
      param['packageName'] = this.packageName;
      param['channel'] = this.channel;
      param['smsSource'] = this.smsSource;
      let strArr = this.userScene.split('-');
      param['type'] = strArr[0];
      param['orderNum'] = strArr[1];
      postFormData(addOrUpdateActivationSms, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          _this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          _this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        _this.loading = false
      }).catch(()=>{
        _this.loading = false
      })
    },


    //获取渠道
    getChannelPackage() {
      getFormData(getAddOrUpdateChannelPackage).then((data) => {
        let {code, msg} = data;
        if (code == 200) {
          console.log(data)
          let channelList = data.data.channelList;
          let packageNameList = data.data.packageNameList;
          channelList.map(item => {
            let obj = {}
            if(item == '0') {
              obj.label = '其他';
              obj.value = item;
            }else {
              obj.label = item;
              obj.value = item;
            }
            this.channelArray.push(obj)
          })
          packageNameList.map(item => {
            let obj = {}
            if(item == '0') {
              obj.label = '其他';
              obj.value = item;
            }else {
              obj.label = item;
              obj.value = item;
            }
            this.packageNameArray.push(obj)
          })
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },

    platformChange(val) {
      if(val == 1) {
        this.channelPackageArray = this.packageNameArray;
      } else if (val == 2) {
        this.channelPackageArray = this.channelArray;
      }
      this.channelPackage = ''
      this.channel = ''
      this.packageName = ''
    },

    cpChange(val) {
      if ( this.platformType == 1) {
        this.channel = ''
        this.packageName = val
      } else if ( this.platformType == 2) {
        this.channel = val
        this.packageName = ''
      }
    },

  },
  mounted() {
    this.getChannelPackage()
    this.channelPackageArray = this.packageNameArray;
    if(this.idx > -1) {
      this.platformType = this.value.activationForm.platformType
      if(this.value.activationForm.platformType == 1) {
        this.channelPackageArray = this.packageNameArray;
        this.channelPackage = this.value.activationForm.packageName;
      } else if (this.value.activationForm.platformType == 2) {
        this.channelPackageArray = this.channelArray;
        this.channelPackage = this.value.activationForm.channel;
      }
      this.userScene = this.value.activationForm.type + '-' + this.value.activationForm.orderNum;
      this.channel = this.value.activationForm.channel;
      this.packageName = this.value.activationForm.packageName;
    }
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
